/**
 * Aura v2 (Okt 2026): Diese App kennt die Leiter mit sechs Leveln.
 *
 * Das Backend kappt Level ohne diesen Header auf 5, weil alte Store-Apps nur
 * fuenf Level kennen (backend/src/utils/auraClientCompat.js). Deshalb geht der
 * Header mit jeder Anfrage an das eigene Backend: axios-Clients
 * (services/api.js, services/ApiService.js), die fetch-Helfer in utils/api.js
 * und utils/authorizedFetch.js, die Token-Erneuerung und /auth/me im AuthContext.
 * Das Backend erlaubt ihn per CORS (backend/src/config/security.js).
 */
export const AURA_CLIENT_HEADER = 'X-EO-Aura';
export const AURA_CLIENT_VERSION = '2';

/** Header-Objekt zum Einmischen: `{ ...AURA_CLIENT_HEADERS, ...headers }` */
export const AURA_CLIENT_HEADERS = Object.freeze({
  [AURA_CLIENT_HEADER]: AURA_CLIENT_VERSION,
});
